import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';

export default {
    apiGetUserQuota: function (strBzbsToken) {
        var strUrl = `${Vue.bzbsConfig.bzbsModuleUrl}/privilege`;
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(strUrl, strBzbsToken).then(res => {
                var result = res.data

                resolve(result);
            }).catch((error) => {
                reject(error);
            });
        });
    },
    apiGetPointsBalance: function (strBzbsToken, transactionId) {
        var params = {
            Transaction: transactionId
        };
        var strUrl = `${Vue.bzbsConfig.bzbsUrl}/redeem/pointsbalance`;
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(strUrl, strBzbsToken, params).then(res => {
                resolve(res.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }
}
